import React from "react";
import classnames from "classnames";

import { accountTypesToEnglishMapping } from "statics/accountTypes";
import { MdOutlineAccountBalance, MdSailing } from "react-icons/md";

import "./AccountBox.scss";

interface AccountBoxProps {
  isFrom?: boolean;
  balance?: number;
  accountName?: string;
  accountType?: string;
  lastFourOfAccount?: string;
  isBank?: boolean;
  bankName?: string;
}

const AccountBox = ({
  isFrom,
  balance,
  accountName,
  accountType,
  lastFourOfAccount,
  isBank,
  bankName,
}: AccountBoxProps) => {
  const acctBoxClass = classnames("transfer-account-box", {
    from: isFrom,
    ["has-balance"]: !!balance,
  });
  return (
    <>
      <div className="acct-src">{isFrom ? "Transfer from" : "Transfer to"}</div>
      <div className={acctBoxClass}>
        <div className="account-icon">
          {isFrom ? (
            <MdOutlineAccountBalance size={16} color="#60A4BF" />
          ) : (
            <MdSailing size={16} color="#60A4BF" />
          )}
        </div>
        <div className="account-details">
          <h3 className="account-name">
            {bankName ||
              (accountTypesToEnglishMapping as Record<string, string>)[
                accountType ?? ""
              ]}
          </h3>

          {isFrom ? (
            <p className="account-info">
              {accountName}
              {isBank && <span>{` • ${lastFourOfAccount}`}</span>}
              {balance && <span>{balance} balance</span>}
            </p>
          ) : (
            <p className="account-info">{accountName}</p>
          )}
        </div>
      </div>
    </>
  );
};

export default AccountBox;
